<template>
	<div class='tax-comparison'>

		<div class='no-table-block' v-if="lpo.inspection_type_id != 10">
			<template v-if='!taxComparison.length'>
				<span>Таблица сравнения ТО(Ф) и ТО(ЛУ) не загружена</span>
				<button class='load-table-btn' @click='getTaxComparison'>Загрузить таблицу</button>
			</template>
			<template v-else>
				
				<button @click='updateTaxComparison'>Обновить таблицу <i class='fa fa-sync-alt'></i></button>
			</template>
		</div>

		<div class='table-container' v-if='taxComparison.length'>
			<table class='table-common'>
				<thead>
					<tr>
						<th rowspan='2'>Источник данных</th>
						<th rowspan='2'>Номер квартала</th>
						<th rowspan='2'>Номер выдела (лп выдела)</th>
						<th rowspan='2'>Площадь выдела (лп выдела), га</th>
						<th colspan='10'>Таксационная характеристика</th>
					</tr>
					<tr>
						<th >Состав</th>
						<th>Порода</th>
						<th>Возраст, лет</th>
						<th>Средняя высота, м</th>
						<th>Средний диаметр, см</th>
						<th>Тип леса</th>
						<!--<th>ТУМ</th>-->
						<th>Полнота</th>
						<th>Бонитет</th>
						<th>Запас, куб. м/га</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="row,ind in taxComparison">
						<template v-if="ind < taxComparison.length-1">
							<td>{{ row.data_source }}</td>
							<td>{{ row.area }}</td>
							<td>{{ row.section + (row.section_lp ? ` (${row.section_lp})` : '') }}</td>
							<td>{{ row.s + (row.s_lp ? ` (${row.s_lp})` : '') }}</td>
						</template>
						<template v-else>
							<td colspan="4">{{ row.data_source }}</td>
						</template>
						<td>{{ row.composition }}</td>
						<td>{{ row.species }}</td>
						<td>{{ row.age }}</td>
						<td>{{ row.h }}</td>
						<td>{{ row.d }}</td>
						<td>{{ row.forest_type }}</td>
						<!--<td>{{ row.tum }}</td>-->
						<td>{{ row.fullness }}</td>
						<td>{{ row.bonitet }}</td>
						<td>{{ row.stock }}</td>
					</tr>
				</tbody>
			</table>
			<span>Ф* - таксационная характеристика по жизнеспособной части насаждения (после удаления деревьев, подлежащих рубке)</span>
		</div>

	</div>
</template>

<script>
	import { mapState, mapActions } from 'vuex';

	export default {
		name: 'TaxComparison',
		computed: {
			taxComparisonFormed() {
				// const source = 
			},

			...mapState('selectedLpo', {
				lpo: state => state.lpo,
				taxComparison: state => state.taxComparison
			})
		},
		methods: {
			...mapActions('selectedLpo', [
				'getTaxComparison',
				'updateTaxComparison'
			])
		}
	};
</script>

<style scoped src='@/style/table.css'></style>

<style scoped>
	.no-table-block {
		margin-bottom: 10px;
	}

	.no-table-block span {
		display: inline-block;

	}

	.load-table-btn {
		margin-left: 10px;
	}

</style>